(function($, window){

    
    // For Google ads and Facebook / Instagram ads

    ['gclid', 'fbclid'].forEach(clickIDParam => {

        // Since auto tagging is enabled on ad campaigns, can expect people to arrive with a gclid / fbclid paramter
        // If it is set, set a cookie called na_gclid / na_fbclid for 30 days
        let clickID = getParameterByName(clickIDParam);
        if (typeof clickID == 'string') {
            clickID = clickID.replace(/[^a-z0-9\.,_-]/gim,"").trim();
            Cookies.set('na_' + clickIDParam, clickID, {expires: 30});
        }
    
        // If there is a contact form, and the cookie is set, add a hidden field with its value to it
        if ($('form.wpcf7-form').length) {
            const na_clickID = Cookies.get('na_' + clickIDParam);
            // Always add hidden fields- otherwise CSV export will omit that field from all output, 
            // because it creates columns based on the fields of the latest entry.
            // So, if no cookie set, set hidden field value to 0
            $('form.wpcf7-form').append($('<input/>').attr({
                    type: 'hidden',
                    name: clickIDParam
                }).val(na_clickID ? na_clickID : 0));
        }
    });

})(jQuery, window);
